import b from 'b_';
import cx from 'classnames';
import { TableRow, Text } from 'platform-components';
import React from 'react';

import './class__add-button.scss';

interface Props {
    mix: string;
    onClick?: () => void;
    textId?: string;
    withoutColor?: boolean;
    children?: React.ReactNode;
}

const ClassAddButton = ({ onClick, mix, textId, children, withoutColor }: Props) => {
    return (
        <TableRow
            contentMix="class__add-button-content"
            isBottomControl
            mix={cx(mix, b('class', 'add-button-row', { 'without-color': withoutColor }))}
            onClick={onClick}
        >
            {children ? children : <Text id={textId} weight={Text.WEIGHT.M} />}
        </TableRow>
    );
};

export default ClassAddButton;
